import InsuranceTypeSelectionStep from '@/pages/members/pages/Onboarding/steps/InsuranceTypeSelectionStep';

import { OnboardingNodeType, OnboardingStepType } from '../../steps/types';
import { OnboardingNode } from '../../types';

export const INSURANCE_TYPE_NODE: OnboardingNode = {
  index: 0,
  key: OnboardingNodeType.INSURANCE_TYPE,
  options: { countsTowardProgressBar: false },
  elements: [
    {
      uid: OnboardingStepType.INSURANCE_TYPE,
      component: (
        <InsuranceTypeSelectionStep
          uid={OnboardingStepType.INSURANCE_TYPE}
          nodeType={OnboardingNodeType.INSURANCE_TYPE}
          displayName="Location & Insurance Provider"
          actionButtonText="Continue"
          showAllContent={true}
        />
      )
    }
  ]
};
